import React, { Component } from 'react';

class Header extends Component {

    render() {
      const dateMonth = new Date().toLocaleString('en-us', {month: 'long'});
      const dateNumber = new Date().getDate();
      let forThe = () => {
        if (window.location.pathname === '/') {
         return "week"
        } else if (window.location.pathname === '/month') {
          return 'month'
        } else {
          return 'day'
        }
      }
      let other = forThe()
      
      return (
          <header className="wrapper">
            <div className="logo">
              <span className="header-title">Your Budget</span>
              <span className="logo-sub">for the {other}</span>
            </div>
            <div className="date">
              <span className="header-title" id="month">{dateMonth}</span>
              <span className="number" id="date">{dateNumber}</span>
            </div>
          </header>
      )
    }
  }

  export default Header;